import api from "../services/api";

function toErrorMessage(err, fallback) {
  return (
    err?.response?.data?.message ||
    err?.apiError?.message ||
    err?.message ||
    fallback
  );
}

function toOpnameApiError(err, fallback) {
  const nextError = new Error(toErrorMessage(err, fallback));
  nextError.status =
    Number(err?.response?.status || err?.apiError?.status || 0) || undefined;
  nextError.code =
    String(err?.response?.data?.code || err?.apiError?.code || "").trim() || undefined;
  nextError.errors = err?.response?.data?.errors || err?.apiError?.errors || undefined;
  return nextError;
}

export async function createOpname(opnameData) {
  try {
    const idempotencyKey = String(
      opnameData?.sourceRequestId || opnameData?.clientMutationId || opnameData?.localCreateId || ""
    ).trim();
    const res = await api.post("/opnames", opnameData, {
      headers: idempotencyKey ? { "X-Idempotency-Key": idempotencyKey } : undefined,
    });
    return res.data;
  } catch (err) {
    throw toOpnameApiError(err, "Fout bij opslaan opname");
  }
}

export async function updateOpname(id, opnameData) {
  try {
    const res = await api.put(`/opnames/${id}`, opnameData);
    return res.data;
  } catch (err) {
    throw toOpnameApiError(err, "Fout bij bijwerken opname");
  }
}

export async function getOpnames() {
  try {
    const res = await api.get("/opnames");
    return res.data;
  } catch (err) {
    throw toOpnameApiError(err, "Fout bij ophalen opnames");
  }
}

export async function getOpname(id) {
  try {
    const res = await api.get(`/opnames/${id}`);
    return res.data;
  } catch (err) {
    throw toOpnameApiError(err, "Fout bij ophalen opname");
  }
}

export async function uploadOpnamePhoto(file, fileName = "") {
  try {
    const formData = new FormData();
    const effectiveName = String(fileName || file?.name || "").trim() || "opname-photo.jpg";
    formData.append("file", file, effectiveName);

    const res = await api.post("/opnames/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return res.data;
  } catch (err) {
    throw toOpnameApiError(err, "Fout bij uploaden opnamefoto");
  }
}

export async function createWorkorderFromOpname(opnameId, payload = {}) {
  try {
    const res = await api.post(`/opnames/${opnameId}/create-workorder`, payload);
    return res.data;
  } catch (err) {
    throw toOpnameApiError(err, "Fout bij werkbon aanmaken vanuit opname");
  }
}
